import { downloadData } from '@aws-amplify/storage';
import * as XLSX from 'xlsx';

const S3_FILE_KEY = 'public/uploads/latest-file.xlsx'; // ✅ Define the fixed file key in S3

export const getLastUploadedData = async () => {
  try {
   // console.log('Fetching the latest file from S3...');

    // ✅ Download the file content
    const { body } = await downloadData({
      path: S3_FILE_KEY,
      options: { accessLevel: 'public' }, // 🔐 Ensure this matches your file's access level
    }).result;

    if (!body) {
      throw new Error('Failed to download file from S3.');
    }

    // ✅ Convert Blob to ArrayBuffer
    const arrayBuffer = await body.arrayBuffer();

    // ✅ Read the workbook
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });

    // ✅ Get the first sheet
    const sheetName = workbook.SheetNames[1];
    const worksheet = workbook.Sheets[sheetName];

    // ✅ Convert to JSON
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    const lastUploadedData = {
      name: workbook.SheetNames[1],
      rowCount: jsonData.length,
      columnCount: Object.keys(jsonData[0]).length,
      rows: jsonData,
    };

  //  console.log('Excel Data Parsed:', jsonData);

    return lastUploadedData;
  } catch (error) {
    console.error('Error fetching the last uploaded data from S3:', error);
    throw error;
  }
};
